export const APP_CONFIG = {
  NAME: "Mikkel Scheike",
  DESC: "Product & Engineering Director at Salary (Shine). Founder of SourceTrust, Digital Habitat, and NextPeak. Building software that matters.",
  PREFIX: "mikkelscheike_v1_",
} as const;

export const STORAGE_KEYS = {
  LANGUAGE: `${APP_CONFIG.PREFIX}-language`,
} as const;

export const LOCALE_CONFIG = {
  DEFAULT: "en",
  SUPPORTED: ["en"] as const,
} as const;

export const SITE_URL = "https://mikkelscheike.com";
